import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Credentials } from './components/Credentials';
import { Services } from './components/Services';
import { ServiceAreas } from './components/ServiceAreas';
import { Testimonials } from './components/Testimonials';
import { Difference } from './components/Difference';
import { Promise } from './components/Promise';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-dark overflow-x-hidden" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Credentials data-id="element-5" />
        <Services data-id="element-6" />
        <ServiceAreas data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Difference data-id="element-9" />
        <Promise data-id="element-10" />
        <CTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
      <FloatingCTA data-id="element-13" />
    </div>;
}